/** @jsxImportSource theme-ui */
import Link from 'next/link';
import SectionHeader from '@components/SectionHeader/SectionHeader';
import SpacingBlock from '@features/cms/components/collections/SpacingBlock/SpacingBlock';
import { ITitleBlock } from '@features/cms/typescript';
import theme from '@styles/theme';
interface TitleBlockProps {
  data: ITitleBlock;
}
const TitleBlock = ({
  data
}: TitleBlockProps) => {
  const {
    title,
    titleLink,
    marginTop,
    marginBottom,
    background
  } = data;
  const spacingBg = background as string || theme.rawColors.neutralWhite;
  return <>
      {Number(marginTop) > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginTop)),
      code: 'mt'
    }} />}
      <div sx={{
      width: '100%',
      backgroundColor: spacingBg,
      padding: ['0 16px', '0 24px', '0 32px', '0 48px', '0 64px', '0 80px']
    }}>
        <div sx={{
        maxWidth: '1920px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }} data-testid="TitleBlock-container">
          {title && <SectionHeader title={title} />}
          {titleLink && <Link href={titleLink}>
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M23.3297 36.667L22.1528 35.4903L36.8102 20.8361L0.00305695 20.9036L1.52356e-06 19.2395L36.8175 19.172L22.1528 4.51037L23.3297 3.33366L40 20.0003L23.3297 36.667Z" fill="#373737" />
              </svg>
            </Link>}
        </div>
      </div>
      {Number(marginBottom) > 0 && <SpacingBlock data={{
      type: 'spacingBlock',
      backgroundColor: spacingBg,
      height: String(Number(marginBottom)),
      code: 'mb'
    }} />}
    </>;
};
export default TitleBlock;